import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ProfileContainer } from "./style";
import * as types from "../../../actions/actionTypes";
import { Menu } from "../../../projectSpecificComponents/menu";
import CurrentProject from "../header/components/currentProject";
import ProjectList from "../header/components/projectList";
import { NON_CUSTODIAN_PANEL } from "../../../constants/panelTypes";
import { getPanel } from "../../../assets/selectProjectUserOrPanel";
import { getNormalizedProjectUserTeams } from "../../../assets/normalizedProjectUserTeams";
import { PROJECT_USER_ID } from "../../../constants/storageKeys";
import { PROJECT_USER_ROLES } from "../../../constants/projectUser";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileMenu: false
    };
    this.toggleProfileMenu = this.toggleProfileMenu.bind(this);
  }

  componentDidMount() {
    if (!this.props.data) {
      this.props.requestInit();
    }
  }

  toggleProfileMenu() {
    this.setState({
      profileMenu: !this.state.profileMenu
    });
  }
  renderTeamOrPanelName = () => {
    const project = this.props.data.project;
    const isManager = getPanel() === NON_CUSTODIAN_PANEL;
    if (isManager) {
      return "پنل مدیریت";
    } else {
      const normalizedProjectUserTeams = getNormalizedProjectUserTeams(
        project.teams,
        project.project_users
      );
      let currentProjectUserRow = normalizedProjectUserTeams.filter(
        pr => pr.id === parseInt(localStorage.getItem(PROJECT_USER_ID))
      );
      if (currentProjectUserRow.length > 0) {
        currentProjectUserRow = currentProjectUserRow[0];
        const teamsCount = normalizedProjectUserTeams.filter(
          pr =>
            pr.project_id === currentProjectUserRow.project_id &&
            pr.user_id === currentProjectUserRow.user_id &&
            pr.user_type === PROJECT_USER_ROLES.CUSTODIAN
        ).length;
        let currentTeam = currentProjectUserRow.project_user_teams;
        if (currentTeam.length > 0 && teamsCount >= 1) {
          currentTeam = currentTeam[0];
          if (!currentTeam.is_default) {
            return `${currentTeam.name}`;
          }
        }
      }
    }
  };
  render() {
    const { profileMenu } = this.state;
    const { data, user } = this.props;
    return (
      <React.Fragment>
        {data && (
          <ProfileContainer>
            <div onClick={this.toggleProfileMenu}>
              <div
                className="profile-project-name"
                title={data && data.project.name}
              >
                {data && data.project.name}
              </div>
              <div className="team-name">{this.renderTeamOrPanelName()}</div>
              <div className="profile-user-name">{user && user.fullName}</div>
            </div>
            <i
              onClick={this.toggleProfileMenu}
              title="حساب ‌کاربری"
              className={
                (profileMenu ? "pressed " : "") +
                "profile-icon icon mapsa-down-arrow"
              }
            />
            {profileMenu && (
              <Menu showMenu={profileMenu} close={this.toggleProfileMenu}>
                <CurrentProject
                  user={user}
                  project={data.project}
                  teamOrPanelName={this.renderTeamOrPanelName()}
                />
                <ProjectList close={this.toggleProfileMenu} />
              </Menu>
            )}
          </ProfileContainer>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = store => {
  return {
    data: store.Init.data,
    user: store.User.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestInit: () => {
      dispatch({ type: types.INIT_REQUEST });
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Profile)
);
